import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import TextInput from "../../common/form/TextInput";
import FormRow from "../../common/form/FormRow";
import React from "react";
import {Control} from "react-hook-form";

type Props = {
    index: number
    control: Control<any>
}


export const LicenseForm = ({ index, control }: Props) => {
    const { t } = useTranslation()

    return (<FormRow>
        <FormFieldBox>
            <TextInput
                readonly={false}
                label={t('users.edit.license')}
                name={`fieldUpdates.${index}.values.0.stringValue`}
                control={control}
                required={true}
                options={[
                    { label: t('users.license.internal'), value: 'INTERNAL' },
                    { label: t('users.license.basic_internal'), value: 'BASIC_INTERNAL' },
                    { label: t('users.license.basic'), value: 'BASIC' },
                    { label: t('users.license.standard'), value: 'STANDARD' },
                    { label: t('users.license.premium'), value: 'PREMIUM' },
                ]}
            />
        </FormFieldBox>
    </FormRow>)
}